import TemperatureIcon from '../../user/images/temperature.svg'
import SnowIcon from '../../user/images/snow.svg'
import './ProductStorageCondition.css'

const ProductStorageCondition = ({ storageCondition }) => {
  const storageConditionMap = {
    refrigerated: { title: 'Produto resfriado', icon: TemperatureIcon },
    frozen: { title: 'Produto congelado', icon: SnowIcon },
  };

  if (!storageConditionMap[storageCondition]) return null;

  const condition = storageConditionMap[storageCondition];

  return (
    <p className="product-storage-condition">
      <span className="product-storage-icon" aria-hidden="true" style={{ marginRight: 8 }}>
        <img src={condition.icon} alt="" />
      </span>
      <span className="product-storage-title">{condition.title}</span>
    </p>
  );
};

export default ProductStorageCondition;